import styles from './ItemMetadataDisplay.module.css';

/**
 * Structured key/value list for item metadata (popover or inline).
 *
 * @param {{ key: string, label: string, value: string }[]} entries
 * @param {boolean} [showLabels=true] — when false, render values only (e.g. single-field popover with label as title)
 */
export function ItemMetadataDetail({ entries, className, showLabels = true }) {
    if (!Array.isArray(entries) || entries.length === 0) return null;

    return (
        <div
            className={[styles.itemInfo, styles.itemInfoDetail, className].filter(Boolean).join(' ')}
            aria-live="polite"
        >
            {entries.map(({ key, label, value }) => (
                <span key={key} className={styles.itemInfoPair}>
                    {showLabels ? (
                        <span className={styles.itemInfoKey}>
                            {label}
                            :
                        </span>
                    ) : null}
                    <span className={styles.itemInfoValue}>{value}</span>
                </span>
            ))}
        </div>
    );
}
